import { compose } from '@wordpress/compose'
import { withSelect } from '@wordpress/data'

const PostTypeCheck = ({ 
	postType, name = 'post', 
	children 
	}) => {
	if ( postType !== name ) {
		return null
	}

	return children
}

export default compose( [
	withSelect( select  => {
		return {
			postType: select( 'core/editor' ).getCurrentPostType(),
		}
	} ),
] )( PostTypeCheck )